import React from 'react';
import './MyToggle.css';

const MyToggle = ({ label, checked, onChange, disabled = false }) => {
  return (
    <div className="my-toggle-container">
      <label className="my-toggle">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <span className="my-toggle-slider"></span>
      </label>
      {label && <span className="my-toggle-label">{label}</span>}
    </div>
  );
};

export default MyToggle;